module.exports = __webpack_public_path__ + "static/media/health-space-image.0b9013c5.svg";